import React from 'react';
// @ts-ignore
import DragSortableList from 'react-drag-sortable';

function Dummy() {
  const list = [
    { content: (<div id="a">test1</div>), classes: ['bigger'], id: 'a' },
    { content: (<div id="b">test2</div>), id: 'b' },
    { content: (<div id="c">test3</div>), classes: ['bigger'], id: 'c' },
    { content: (<div id="d">test4</div>), id: 'd' },
  ];
  const onSort = (sortedList:any, dropEvent:any) => {
    console.log('sortedList', sortedList);
    console.log(dropEvent.currentTarget.children[0].id);
  };
  return (
    <div>
      <DragSortableList items={list} onSort={onSort} type="vertical" />
    </div>
  );
}

export default Dummy;
